'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import ServicoAssinaturaPaginaMobile from './Designs/Mobile';
import ServicoAssinaturaPaginaDesktop from './Designs/Desktop';
import { useRouter } from 'next/navigation';
import useServicoAssinaturaPageHook from './hook/useServicoAssinaturaPageHook';

export type ServicoAssinaturaPaginaProps = {
  $ServicoAssinaturaSlug: string;
};

export default function ServicoAssinaturaPagina(
  props: ServicoAssinaturaPaginaProps,
) {
  const { breakpoint } = useBreakpoint();
  const router = useRouter();

  const propsServicoAssinaturaPagina = useServicoAssinaturaPageHook(
    props.$ServicoAssinaturaSlug,
    router,
  );

  return breakpoint === 'mobile' ? (
    <ServicoAssinaturaPaginaMobile {...propsServicoAssinaturaPagina} />
  ) : (
    <ServicoAssinaturaPaginaDesktop {...propsServicoAssinaturaPagina} />
  );
}
